import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  TextField,
  Grid,
  Typography,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  getRole,
  getRolePartyBased,
  settlement,
  settlementTypeAction,
  getListOfOrder,
} from "../../actions/settlementActions";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
const CreateSettlements = () => {
  const dispatch = useDispatch();
  const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;

  const [roles, setRoles] = useState([]);
  const [otherParty, setOtherParty] = useState([]);
  const [selectedCollector, setSelectedCollector] = useState(null);
  const [selectedReceiver, setSelectedReceiver] = useState(null);
  const [settlementTypeList, setSettlementTypeList] = useState([]);
  const [selectedSettlementType, setSelectedSettlementType] = useState(null);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const navigate = useNavigate();
  // Fetch roles and settlement types on mount
  const redirect = (row) => {
    navigate(`/app/management/create-settlement-details`, { state: { row } });
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const roleResult = await dispatch(getRole(customerId));
        const settlementResult = await dispatch(
          settlementTypeAction(customerId)
        );
        setRoles(roleResult?.data || []);
        setSettlementTypeList(settlementResult?.data || []);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchInitialData();
  }, [dispatch, customerId]);

  const handleRoleChange = async (event, newValue) => {
    if (newValue) {
      setSelectedCollector(newValue);
      try {
        setLoading(true);
        const roleResult = await dispatch(
          getRolePartyBased(newValue, customerId)
        );
        setOtherParty(roleResult || []);
      } catch (error) {
        console.error("Error fetching collector role data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleReceiverChange = async (event, newValue) => {
    if (newValue) {
      setSelectedReceiver(newValue);
      try {
        setLoading(true);
        await dispatch(getRolePartyBased(newValue.value, customerId));
        const listRes = await dispatch(
          getListOfOrder(newValue, selectedCollector, customerId)
        );
        setList(listRes || []);
      } catch (error) {
        console.error("Error fetching receiver role data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSettlementTypeChange = (event, newValue) => {
    setSelectedSettlementType(newValue);
  };

  const handleCreateOrder = async () => {
    try {
      const res = await dispatch(
        settlement(selectedOrders, selectedSettlementType, customerId)
      );
      if (res?.data?.message) {
        setMsg(res.data.message);
        setDialogOpen(true);
        setSelectedOrders([]);
        setTimeout(() => {
          setDialogOpen(false);
          setMsg("");
          navigate('/app/management/settlement');
        }, 3000);
      }
    } catch (error) {
      console.error("Error creating settlement:", error);
    }
  };

  // DataGrid columns
  const columns = [
    { field: "ondcOrderId", headerName: "Order ID", flex: 1 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "price", headerName: "Price", flex: 1 },
    { field: "address", headerName: "Address", flex: 2 },
    { field: "itemCount", headerName: "Item Count", flex: 1 },
      {
                field: "action",
                disableClickEventBubbling: true,
                headerName: "Action",
                renderCell: (params) => {
                  const redirectToView = () => {
                    redirect(params.row);
                  };
          
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center", // vertical center alignment
                        justifyContent: "flex-start",
                        gap: 1,
                      }}
                    >
                      <Tooltip title="View details">
                        <Box sx={{ cursor: "pointer" }} onClick={redirectToView}>
                          <RemoveRedEyeRoundedIcon />
                        </Box>
                      </Tooltip>
                      {/* <Tooltip title="View details">
                        <Box sx={{ cursor: "pointer" }} onClick={redirectToEdit}>
                          <EditIcon />
                        </Box> 
                      </Tooltip>*/}
                    </Box>
                  );
                },
                flex: 1,
              },
  ];

  // Transform list for DataGrid
// Pass full order object as DataGrid row
const rows = list.map((order) => ({
  ...order, // keep full object
  id: order?._id, // DataGrid requires an id
  ondcOrderId: order?.ondcOrderId,
  name: order?.order?.billing?.name,
  price: order?.order?.quote?.price?.value,
  address: `${order?.order?.billing?.address?.name || ""}, ${order?.order?.billing?.address?.building || ""}, ${order?.order?.billing?.address?.city || ""}, ${order?.order?.billing?.address?.state || ""}, ${order?.order?.billing?.address?.country || ""}`,
  itemCount: order?.order?.items?.length || 0,
}));


  return (
    <Box
      sx={{
        maxWidth: "100%",
        padding: 4,
        borderRadius: 2,
        margin: "auto",
        marginTop: 4,
        backgroundColor: "#fff",
      }}
    >
      <Grid container spacing={3}>
      <Grid item xs={12}>
              <Typography
                variant="h3"
                color="textPrimary"
                style={{ marginLeft: "0em" }}
              >
                Create Settlement
              </Typography>
            </Grid>
        <Grid item xs={12} md={6}>
          <Autocomplete
            options={roles}
            value={selectedCollector}
            onChange={handleRoleChange}
            getOptionLabel={(option) => option || ""}
            renderInput={(params) => (
              <TextField {...params} label="My Role" fullWidth />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Autocomplete
            options={otherParty}
            value={selectedReceiver}
            onChange={handleReceiverChange}
            getOptionLabel={(option) => option || ""}
            renderInput={(params) => (
              <TextField {...params} label="Other Party" fullWidth />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Autocomplete
            options={settlementTypeList}
            value={selectedSettlementType}
            onChange={handleSettlementTypeChange}
            getOptionLabel={(option) => option || ""}
            renderInput={(params) => (
              <TextField {...params} label="Settlement Type" fullWidth />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            List of Orders
          </Typography>
          <div style={{ height: 500, width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              checkboxSelection
              disableRowSelectionOnClick
              selectionModel={selectedOrders}
              onSelectionModelChange={(newSelection) =>
                setSelectedOrders(newSelection)
              }
            />
          </div>
        </Grid>

        <Grid item xs={12} sx={{ textAlign: "left", mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateOrder}
          >
            Send For Settlement
          </Button>
        </Grid>
      </Grid>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Settlement Status</DialogTitle>
        <DialogContent>
          <Typography>{msg}</Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default CreateSettlements;
